/*

=========================================================
* Now UI Kit React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-kit-react
* Copyright 2020 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/master/LICENSE.md)

* Designed by www.invisionapp.com Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.4.0";
import "assets/demo/demo.css?v=1.4.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.4.0";
// pages for this kit
import Index from "views/Index.js";
import NucleoIcons from "views/NucleoIcons.js";
import LoginPage from "views/examples/LoginPage.js";
import LandingPage from "views/examples/LandingPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import Privacy from "views/Privacy";
import GooglePicker from "views/GooglePicker";
import GooglePickerAirPrint from "views/GooglePickerAirPrint";
import OneDrivePicker from "views/OneDrivePicker";
import AirPrinterPrivacy from "views/AirPrinterPrivacy";
import AirPrinterTerms from "views/AirPrinterTerms";
import DataMigrationPrivacy from "views/DataMigrationPrivacy";
import DataMigrationTerms from "views/DataMigrationTerms";
import ARDrawPrivacy from "views/ARDrawPrivacy";
import ARDrawTerms from "views/ARDrawTerms";
import LocationTrackerPrivacy from "views/LocationTrackerPrivacy";
import LocationTrackerTerms from "views/LocationTrackerTerms";
import PdfReaderPrivacy from "views/PdfReaderPrivacy";
import PdfReaderTerms from "views/PdfReaderTerms";
import KeyboardPrivacy from "views/KeyboardPrivacy";
import KeyboardTerms from "views/KeyboardTerms";
import IdolPrankPrivacy from "views/IdolPrankPrivacy";
import IdolPrankTerms from "views/IdolPrankTerms";
import ZipLockPrivacy from "views/ZipLockPrivacy";
import ZipLockTerms from "views/ZipLockTerms";
import VideoDownloaderPrivacy from "views/VideoDownloaderPrivacy";
import VideoDownloaderTerms from "views/VideoDownloaderTerms";


ReactDOM.render(
  <BrowserRouter>
      <Switch>
      <Route
          path="/keyboard-emoji/privacy"
          render={(props) => <KeyboardPrivacy {...props} />}
        />

        <Route
          path="/keyboard-emoji/terms"
          render={(props) => <KeyboardTerms {...props} />}
        />

        <Route
          path="/ziplock/privacy"
          render={(props) => <ZipLockPrivacy {...props} />}
        />

        <Route
          path="/ziplock/terms"
          render={(props) => <ZipLockTerms {...props} />}
        />

        <Route
          path="/downloader/privacy"
          render={(props) => <VideoDownloaderPrivacy {...props} />}
        />

        <Route
          path="/downloader/terms"
          render={(props) => <VideoDownloaderTerms {...props} />}
        />

<Route
          path="/idol-prank/privacy"
          render={(props) => <IdolPrankPrivacy {...props} />}
        />

        <Route
          path="/idol-prank/terms"
          render={(props) => <IdolPrankTerms {...props} />}
        />

      <Route
          path="/privacy"
          render={(props) => <Privacy {...props} />}
        />

        <Route
          path="/airprinter/privacy"
          render={(props) => <AirPrinterPrivacy {...props} />}
        />

        <Route
          path="/airprinter/terms"
          render={(props) => <AirPrinterTerms {...props} />}
        />

<Route
          path="/armaster/privacy"
          render={(props) => <ARDrawPrivacy {...props} />}
        />

        <Route
          path="/armaster/terms"
          render={(props) => <ARDrawTerms {...props} />}
        />

<Route
          path="/location-tracker/privacy"
          render={(props) => <LocationTrackerPrivacy {...props} />}
        />

        <Route
          path="/location-tracker/terms"
          render={(props) => <LocationTrackerTerms {...props} />}
        />

<Route
          path="/pdf-reader/privacy"
          render={(props) => <PdfReaderPrivacy {...props} />}
        />

        <Route
          path="/pdf-reader/terms"
          render={(props) => <PdfReaderTerms {...props} />}
        />


<Route
          path="/smartprint/privacy"
          render={(props) => <AirPrinterPrivacy {...props} />}
        />

        <Route
          path="/smartprint/terms"
          render={(props) => <AirPrinterTerms {...props} />}
        />


<Route
          path="/data-migration/privacy"
          render={(props) => <DataMigrationPrivacy {...props} />}
        />

        <Route
          path="/data-migration/terms"
          render={(props) => <DataMigrationTerms {...props} />}
        />

        <Route
          path="/picker"
          render={(props) => <GooglePicker {...props} />}
        />
        <Route
          path="/air-print-picker"
          render={(props) => <GooglePickerAirPrint {...props} />}
        />
        <Route
          path="/picker-one-drive"
          render={(props) => <OneDrivePicker {...props} />}
        />
        <Route path="/" render={(props) => <Index {...props} />} />
        <Route
          path="/nucleo-icons"
          render={(props) => <NucleoIcons {...props} />}
        />
        <Route
          path="/landing-page"
          render={(props) => <LandingPage {...props} />}
        />
        <Route
          path="/profile-page"
          render={(props) => <ProfilePage {...props} />}
        />
        <Route
          path="/login-page"
          render={(props) => <LoginPage {...props} />}
        />
      
        {/* <Redirect to="/" /> */}
        {/* <Redirect from="/" to="/" /> */}
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
